import type { ChangeEvent } from "react";
import {
  Controller,
  type FieldError,
  type FieldValues,
  type UseControllerProps,
} from "react-hook-form";
import { Input, type InputProps } from "./input";

export const ControlledInput = <FormType extends FieldValues>({
  control,
  name,
  inputType = "default",
  label,
  rules,
  onValueChange,
  onValidationError,
  ...props
}: InputProps &
  UseControllerProps<FormType> & {
    onValueChange?: (value: ChangeEvent<HTMLInputElement>) => void;
    onValidationError?: (error: FieldError) => void;
  }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => {
        if (fieldState.error && onValidationError) {
          onValidationError(fieldState.error);
        }

        return (
          <Input
            id={`${name}-input`}
            inputType={inputType}
            label={label}
            value={field.value ?? ""}
            onChange={value => {
              field.onChange(value);
              onValueChange?.(value);
            }}
            errorMessage={fieldState.error?.message}
            {...props}
          />
        );
      }}
    />
  );
};
